<script setup>
import { ref, watch } from 'vue';
import Draggable from 'vuedraggable';

import KanbanCard from './KanbanCard.vue';

const props = defineProps({
  step: {
    type: Object,
    required: true,
  },
  tasks: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['task-moved']);

const localTasks = ref([...props.tasks]);

watch(
  () => props.tasks,
  newTasks => {
    localTasks.value = [...newTasks];
  }
);

const handleChange = event => {
  if (event.added) {
    emit('task-moved', {
      taskId: event.added.element.id,
      boardStepId: props.step.id,
    });
  }
};
</script>

<template>
  <div class="flex flex-col w-80 shrink-0 bg-n-alpha-1 rounded-lg">
    <header class="flex items-center gap-2 px-3 py-2 border-b border-n-weak">
      <span
        class="size-3 rounded-full"
        :style="{ backgroundColor: step.color || '#475569' }"
      />
      <h3 class="text-sm font-semibold text-n-slate-12 flex-1 truncate">
        {{ step.name }}
      </h3>
      <span class="text-xs text-n-slate-11">{{ localTasks.length }}</span>
    </header>
    <Draggable
      v-model="localTasks"
      :group="{ name: 'kanban-tasks' }"
      item-key="id"
      class="flex flex-col gap-2 p-3 min-h-[120px] flex-1 overflow-y-auto"
      ghost-class="opacity-40"
      @change="handleChange"
    >
      <template #item="{ element: task }">
        <KanbanCard :task="task" />
      </template>
    </Draggable>
  </div>
</template>
